( function($) {

    /**
     * Fusion Toggle Section
     */
    if ( $('.fusion-flex-container.has-section-toggle').length !== 0 ) {
        const toggleSections = $('.fusion-flex-container.has-section-toggle');

        toggleSections.each( function(e) {
            const toggle = $(this).find('a.view-more-toggle');
            const toggleOpenSection = $(this).next();

            toggle.click( function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                toggleOpenSection.toggleClass('open');
            });
        });
    }

})(jQuery);